import { createSelector } from '@ngrx/store';
import { selectEntitlementsState } from '../reducers';
import {
  selectAllFeatures,
  selectAllPrivileges,
  selectAllRoles,
  selectRoleEntities as selectRoleEntitiesHelper,
  selectTotalFeatures,
  selectTotalPrivileges,
  selectTotalRoles,
} from '../reducers/entitlements.reducer';

export const selectRoleName = (roleId: string) =>
  createSelector(
    selectEntitlementsState,
    (state) => selectRoleEntitiesHelper(state.roles)[roleId]?.name || roleId,
  );

export const selectRoleEntities = createSelector(
  selectEntitlementsState,
  (state) => selectRoleEntitiesHelper(state.roles),
);

export const selectHasFeatures = createSelector(
  selectEntitlementsState,
  (state) => selectTotalFeatures(state.features) > 0,
);

export const selectHasPrivileges = createSelector(
  selectEntitlementsState,
  (state) => selectTotalPrivileges(state.privileges) > 0,
);

export const selectHasRoles = createSelector(
  selectEntitlementsState,
  (state) => selectTotalRoles(state.roles) > 0,
);

export const selectFeatures = createSelector(selectEntitlementsState, (state) =>
  selectAllFeatures(state.features),
);

export const selectPrivileges = createSelector(
  selectEntitlementsState,
  (state) => selectAllPrivileges(state.privileges),
);

export const selectRoles = createSelector(selectEntitlementsState, (state) =>
  selectAllRoles(state.roles),
);
